import SvgIcon from '@mui/material/SvgIcon';
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from '../../util/reactIntl';
import { ShareButtonBase } from './ShareButtonBase';
import { getFullURL } from './shareUtils';

// Custom Facebook Messenger icon
const MessengerIcon = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="100"
      height="100"
      viewBox="0 0 30 30"
    >
      <path d="M 15 3 C 8.373 3 3 8.149 3 14.5 C 3 17.901215 4.5506695 20.947232 7 23.052734 L 7 28 L 11.835938 25.582031 C 12.845524 25.846308 13.903007 26 15 26 C 21.627 26 27 20.851 27 14.5 C 27 8.149 21.627 3 15 3 z M 13.861328 11.357422 L 16.8125 14.3125 L 22.083984 11.357422 L 16.138672 17.800781 L 13.255859 14.703125 L 7.8457031 17.730469 L 13.861328 11.357422 z"></path>
    </svg>
  </SvgIcon>
);

export const MessengerButton = ({ url, text, sharedItemName, shareOrigin, ...rest }) => {
  const intl = useIntl();
  const shareUrl = url || getFullURL();

  const handleShare = () => {
    // For mobile SMS
    if (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) {
      window.location.href = `sms:?&body=${encodeURIComponent(shareUrl)}`;
    } else {
      // For Facebook Messenger send dialog
      // Documentation: https://developers.facebook.com/docs/sharing/reference/send-dialog
      const messengerUrl = `https://www.facebook.com/dialog/send?app_id=936349663622036&link=${encodeURIComponent(
        shareUrl
      )}&redirect_uri=${encodeURIComponent(window.location.href)}&display=popup`;

      window.open(messengerUrl, '_blank', 'width=600,height=400');
    }
  };

  return (
    <ShareButtonBase
      icon={<MessengerIcon />}
      label={intl.formatMessage({ id: 'ShareActions.messenger', defaultMessage: 'Messenger' })}
      url={shareUrl}
      sharedItemName={sharedItemName}
      shareOrigin={shareOrigin}
      onClick={handleShare}
      {...rest}
    />
  );
};

MessengerButton.propTypes = {
  url: PropTypes.string,
  text: PropTypes.string,
  sharedItemName: PropTypes.string,
  shareOrigin: PropTypes.string,
};

MessengerButton.defaultProps = {
  url: '',
  text: '',
  sharedItemName: '',
  shareOrigin: '',
};
